import React from 'react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import DropdownItem from '../DropdownItem';
import WarningPopup from '../WarningPopup';

const StandardTools = ({
  allowDelete,
  allowRead,
  asHref,
  children,
  deleteIcon = 'trash alternate',
  deleteMessage = 'actions.delete',
  deleteWarningMessage,
  href,
  onDelete,
}) => (
  <>
    {allowRead && (
    <DropdownItem
      icon="edit"
      textId="actions.open"
      href={href}
      target={asHref ? '_blank' : undefined}
    />
    )}
    {children}
    {allowDelete && (
    <WarningPopup messageId={deleteWarningMessage} disabled={!hasMinimumLength(deleteWarningMessage)}>
      <DropdownItem className="delete-file" icon={deleteIcon} textId={deleteMessage} onClick={onDelete} />
    </WarningPopup>
    )}
  </>
);

export default StandardTools;
